import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from '../assets/img/logo.png';
import navIcon1 from '../assets/img/instagram.png';
import navIcon2 from '../assets/img/tik-tok.png';
import navIcon3 from '../assets/img/twitch.png';

const valueOfPage = null

export const NavBar = () => {

  //const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);




  /*
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])
  


  const onUpdateActiveLink = (value) => {
    valueOfPage = value
    setActiveLink(value);
  }*/

  return (
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/home" className="navbar-link" >HOME</Nav.Link>
              <Nav.Link href="/configurazioni" className="navbar-link" >Configurazioni</Nav.Link>
            </Nav>
            
          </Navbar.Collapse>
        </Container>
      </Navbar>
  )
}